import { Box, Text, useMediaQuery } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Card from "./Card";
import { GetAchievementsDetails } from "../../Services/firebase";
import SectionTitle from "../Common/SectionTitle";
import Loader from "../Loader";

const Achievements = () => {
  const [achievements, setAchievements] = useState([]);
  const [isLargerThan1120] = useMediaQuery("(min-width: 1120px)");
  const [loading, setLoading] = useState(true);
  const fetchAchievemntsData = async () => {
    setLoading(true);
    const results = GetAchievementsDetails();
    results
      .then((achieves) => {
        setLoading(false);
        if (achieves?.length > 0) {
          const res = achieves.filter((item) => item.id !== "leetcode");
          setAchievements(res);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("error:", err);
      });
  };

  useEffect(() => {
    fetchAchievemntsData();
  }, []);
  return (
    <Box marginTop="9rem">
      <SectionTitle title="Achievements Unlocked" />
      <Box>
        {!loading && achievements.length > 0 ? (
          achievements.map((achieve, idx) => {
            return (
              <Card
                key={achieve.id}
                achievement={achieve}
                isLargerThan1120={isLargerThan1120}
                direction={
                  isLargerThan1120
                    ? idx % 2 === 0
                      ? "row"
                      : "row-reverse"
                    : "column-reverse"
                }
              />
            );
          })
        ) : (
          <Loader />
        )}
      </Box>
    </Box>
  );
};

export default Achievements;
